import { PublicCourse } from '@/types/course';
import CourseCard from './CourseCard';
import { SkeletonGrid, ErrorState } from '@/components/common';

interface CourseGridProps {
  courses: PublicCourse[];
  onCourseClick?: (courseId: number) => void;
  loading?: boolean;
  error?: string | null;
  onRetry?: () => void;
  className?: string;
}

const CourseGrid = ({
  courses,
  onCourseClick,
  loading = false,
  error = null,
  onRetry,
  className = '',
}: CourseGridProps) => {
  const EmptyState = () => (
    <div className="col-span-full flex flex-col items-center justify-center py-12 text-center">
      <div className="w-24 h-24 mx-auto mb-4 text-m2-outline">
        <span className="material-symbols-outlined text-7xl">menu_book</span>
      </div>
      <h3 className="text-lg font-medium text-m2-on-surface mb-2">Chưa có khóa học</h3>
      <p className="text-m2-on-surface-variant max-w-sm">
        Hiện chưa có khóa học nào được công bố. Vui lòng quay lại sau.
      </p>
    </div>
  );

  if (loading) {
    return <SkeletonGrid count={8} className={className} />;
  }

  if (error) {
    return (
      <div className={className}>
        <ErrorState
          title="Không tải được danh sách khóa học"
          message={error}
          onRetry={onRetry}
          retryText="Thử lại"
        />
      </div>
    );
  }

  if (courses.length === 0) {
    return (
      <div className={`grid grid-cols-1 ${className}`}>
        <EmptyState />
      </div>
    );
  }

  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${className}`}
    >
      {courses.map((course) => (
        <CourseCard
          key={course.slug ?? course.hashId ?? course.id}
          course={course}
          onClick={onCourseClick}
        />
      ))}
    </div>
  );
};

export default CourseGrid;
